import { observable } from 'mobx'
import { useStickyTop } from 'config/appConfig'

/**
 * ScrollState is a class that manages scroll state and operations.
 * It tracks the scroll position and provides methods like scrollToTop()
 * to smooth scroll to a specific position.
 */
class ScrollState {
  @observable headerHeight = 0

  /**
   * Recursively gets the scroll top position of a node by walking up the offsetParent chain and summing the offsetTop values.
   *
   * @param {HTMLElement} node - The node to get the scroll top position for
   * @returns {number} The scroll top position of the node
   */
  getScrollTopPosition = node => {
    const offsetParent = node && node.offsetParent
    if (offsetParent) {
      return node.offsetTop + this.getScrollTopPosition(offsetParent)
    } else {
      return node?.offsetTop
    }
  }

  /**
   * Scrolls the window to the top smoothly.
   *
   * @param {HTMLElement} node - The node to scroll to the top of
   */
  scrollToTop = node => {
    let top
    const defaultTop =
      this.getScrollTopPosition(node) - (useStickyTop ? this.headerHeight : 200)
    try {
      const { isEquinoxMysite } = require('./mySiteUtils')
      const isEQMysite = isEquinoxMysite()
      if (isEQMysite) {
        top = 0
      } else {
        top = defaultTop
      }
    } catch (error) {
      console.warn('Error checking mysite status, using default scroll:', error)
      top = defaultTop
    }
    if (typeof window === 'object') {
      window.scroll({
        left: 0,
        top,
        behavior: 'smooth',
      })
    }

    // scroll behaviour not smooth, need support for all browsers
    // node.scrollIntoView({ behaviour: 'smooth' })
  }

  smoothScrollToModalElement = elementId => {
    const targetElement = document.querySelector(elementId)
    if (targetElement) {
      targetElement.scrollIntoView({
        top: targetElement.offsetTop,
        behavior: 'smooth',
      })
    }
  }

  calculateScrollOffset = (isMysite = false, isPOSite = false) => {
    const windowWidth = typeof window !== 'undefined' ? window.innerWidth : 1024

    if (windowWidth < 400) {
      return isMysite ? 180 : 200
    } else if (windowWidth < 1024) {
      return isMysite ? 220 : 150
    } else {
      return isMysite ? 347 : 220
    }
  }
}

const scrollState = new ScrollState()

export { scrollState }
